import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.scss'

const Radio = (props) => {
  const { checked, className, label, name, onChange, title, disabled } = props

  return (
    <label className={classNames('radio', className, { checked, disabled })} title={title}>
      <input
        type="radio"
        checked={checked}
        name={name}
        value={label}
        onChange={onChange}
        disabled={disabled}
        className="radio__input"
      />
      <div className={classNames('radio__text', { 'radio__text--checked': checked })}>
        <span>{label}</span>
      </div>
    </label>
  )
}

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
}

Radio.defaultProps = {
  name: '',
  label: '',
  onChange: () => {},
  checked: false,
  disabled: false,
  className: '',
  title: '',
}

export default Radio
